export default "__VITE_ASSET__CEX8Z8qN__";